import React from 'react';

import ProteinChainPreview from 'molbio/proteins/complex/ProteinChainPreview';
import {ProteinComplex} from 'molbio/proteins/complex/ProteinComplexConstants';

export default function ProteinComplexPreviewBody({
  proteins,
}: {
  proteins: Array<ProteinComplex>;
}): JSX.Element {
  return (
    <div className="container u-spacing-top">
      {proteins.map((protein, i) => (
        <ProteinChainPreview key={i} name={protein.name} aminoAcids={protein.aminoAcids} />
      ))}
    </div>
  );
}
